import React from 'react';
import {useDispatch} from 'react-redux';

import * as S from './SimilarHotelDetails.styles';
import {AltAccoRatingsRenderer} from '@stencil/gi-components/src/AltAccoRatingsRenderer/AltAccoRatingsRenderer';

import {ratingColorSelector} from '../../../../../../shared/utils/UI';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {gaConfig} from '@stencil/hotels-config';

// Omniture Imports
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

const SimilarHotelDetails: React.FC<{
  hotelRating: number;
  hotelName: string;
  hotelLocation: string;
  userRating: number;
  noOfReviews: number;
  detailPageUrl: string;
  onClick: Function;
  currentHotel?: boolean;
  index?: number;
  isAltAcco: boolean;
  propertyType?: string;
}> = ({
  hotelRating,
  hotelName,
  hotelLocation,
  userRating,
  noOfReviews,
  detailPageUrl,
  onClick,
  currentHotel = false,
  index,
  isAltAcco,
  propertyType,
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <S.HotelCategoryWrapDiv>
        <AltAccoRatingsRenderer
          hotelStarRating={hotelRating as number}
          isAltAcco={isAltAcco}
          additionalParams={{
            defaultComponent: (starIndex: number) => (
              <S.StarDiv key={'hotelStarIconSimilarDweb' + starIndex}></S.StarDiv>
            ),
            isCarousel: true,
          }}
        />
        <S.HotelCatgegory isAltAcco={isAltAcco}>{propertyType || 'Hotel'}</S.HotelCatgegory>
      </S.HotelCategoryWrapDiv>

      <S.HotelNameLocationWrapper>
        {!!hotelName && (
          <S.ReviewHotelNameHeading>
            {!currentHotel ? (
              <S.HotelNameTextAnchor
                href={detailPageUrl}
                onClick={e => e.stopPropagation()}
                rel="noopener"
              >
                <S.HotelNameTextSpan
                  onClick={event => {
                    event.preventDefault();
                    onClick(event);
                    dispatch(
                      omnitureThunk(
                        omnitureConfig.pages.DetailsUnif,
                        omnitureConfig.events.ctaClick,
                        {
                          cta: {
                            name: `${DetailsPageComponents.SimilarHotelDetails}_${
                              detailsClick.similarHotel
                            }_${index + 1}`,
                            type: omnitureConfig.ctaType.Button,
                            componentName: DetailsPageComponents.SimilarHotelDetails,
                            destination: '',
                          },
                        },
                      ),
                    );
                  }}
                >
                  {hotelName}
                </S.HotelNameTextSpan>
              </S.HotelNameTextAnchor>
            ) : (
              hotelName
            )}
          </S.ReviewHotelNameHeading>
        )}
        {!!hotelLocation && <S.AddressSpan>{hotelLocation}</S.AddressSpan>}
      </S.HotelNameLocationWrapper>
      <S.ReviewByUserDiv>
        <S.ReviewPointWrapDiv
          showRating={userRating}
          backgroundColor={ratingColorSelector(Number(userRating))}
        >
          {!!userRating && <S.ReviewPointTextSpan>{userRating}/5</S.ReviewPointTextSpan>}
        </S.ReviewPointWrapDiv>

        {!!noOfReviews && <S.AddressSpan>{noOfReviews} reviews</S.AddressSpan>}
      </S.ReviewByUserDiv>
    </>
  );
};

export default SimilarHotelDetails;
